/* eslint-disable react/prop-types */
import React from 'react';
import { Box, HStack, VStack, chakra, Divider } from '@chakra-ui/react';
import EventCardDate from '../../../../../../components/surfaces/event-card/event-card-date/index.web';
import COLORS from '../../../../../../constants/colors';
import Text from '../../../../../../components/content/text';
import FONTS from '../../../../../../constants/fonts';
import Tag from '../../../../../../components/content/tag/index.web';
import { useTranslation } from 'react-i18next';
import useFormatDate from '../../../../../../hooks/format-date/useFormatDate';
import moment from 'moment';
import { tKeys } from '../../../../../../translations/keys';
import ButtonPresenceStatus from '../../../components/inputs/button-present-status/index.web';
import { PresenceStatus } from '../../types';
import Icon from '../../../../../../components/content/icon';
import { Linking } from 'react-native';
function EventDetailsMainInformationsComponent({ event, isAdmin, isCurrentUserInvited, handlePresenceStatus, currentUserInvitee, eventLocalization, eventTimezone, eventUrl, eventShouldBeRecorded, eventWillBeRecorded, }) {
    // Attributes
    const { t } = useTranslation();
    const { formatDateTime } = useFormatDate();
    function EventUrlText() {
        return (<Box 
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick={async () => await Linking.openURL(eventUrl)} cursor={'pointer'} _hover={{ textDecoration: 'underline' }} transition="all 0.2s">
        <Text color={COLORS.Blue.value} font={FONTS.T1.T14Px.Medium500.value} numberOfLines={1}>
          {t('event.details.join_meeting')}
        </Text>
      </Box>);
    }
    function formatTimeWithTimezone(date, showTimezone = false) {
        const time = formatDateTime({
            date: moment.utc(date).toDate(),
            format: 'HH:mm',
            formatWithTimezone: false,
        });
        if (showTimezone && eventTimezone) {
            const utcMatch = eventTimezone.match(/UTC[+-]\d{2}:\d{2}/);
            const utcString = utcMatch ? utcMatch[0] : '';
            return `${time} (${utcString})`;
        }
        return time;
    }
    // Render
    return (<VStack width={'full'} alignItems={'flex-start'} borderRadius={'1rem'} p={'1.25rem'} backgroundColor={COLORS.White.T500.value} borderWidth={1} borderColor={COLORS.Line.value} spacing={'1rem'}>
      {/* Header with Date and Title */}
      <HStack width={'full'} spacing={'1rem'} alignItems={'flex-start'}>
        <EventCardDate date={event?.startDate} py={'0.5rem'} boxShadow="0px 2px 4px rgba(0, 0, 0, 0.05)" minH={'4.25rem'}/>
        <VStack spacing={'.5rem'} flex={1} alignItems={'flex-start'}>
          <Text font={FONTS.T1.T20Px.Bold700.value}>
            {event?.name}
          </Text>
          <HStack spacing={'1rem'} alignItems={'center'} flexWrap="wrap">
            <HStack spacing={'.5rem'} alignItems={'center'}>
              {/* <Icon name="clock-black" height={16} width={16} /> */}
              <Text font={FONTS.T1.T14Px.Regular400.value} color={COLORS.Text.T400.value}>
                {`${formatTimeWithTimezone(event?.startDate)} - ${formatTimeWithTimezone(event?.endDate, true)}`}
              </Text>
            </HStack>
            <Tag font={FONTS.T1.T12Px.Medium500.value} backgroundColor={COLORS.Line.value} color={COLORS.Text.T400.value}>
              {t(event?.type?.name)}
            </Tag>
          </HStack>
        </VStack>
      </HStack>

      <Divider borderColor={COLORS.Line.value}/>

      {/* Event Details - Compact Layout */}
      <HStack width={'full'} spacing={'2rem'} flexWrap={'wrap'}>
        {eventLocalization && (<HStack spacing={'.75rem'} alignItems={'center'}>
            <Icon name="map-pin-black" width={16} height={16} fill={'transparent'}/>
            <Text font={FONTS.T1.T14Px.Regular400.value} color={COLORS.Text.T400.value}>
              {eventLocalization}
            </Text>
          </HStack>)}

        {eventUrl && (<HStack spacing={'.75rem'} alignItems={'center'}>
            <Icon name="clip" width={16} height={16}/>
            <EventUrlText />
            {eventShouldBeRecorded && (<Icon name="ai-assist" width={16} height={16} fill={!eventWillBeRecorded
                    ? COLORS.Error.T500.value
                    : COLORS.Success.T500.value}/>)}
          </HStack>)}
      </HStack>

      {/* Presence Buttons - Horizontal Layout */}
      {isCurrentUserInvited &&
            event?.publishedOn &&
            !moment(event?.startDate).isBefore(moment()) && (<>
            <Divider borderColor={COLORS.Line.value}/>
            <HStack spacing={'.5rem'} width={'full'} justifyContent={'flex-end'}>
              <ButtonPresenceStatus title={t(tKeys.home.calendar.event_details.information.presence.status
                .present)} onPress={() => handlePresenceStatus(PresenceStatus?.Present)} iconName={'check'} isSelected={!!currentUserInvitee?.acceptedOn &&
                !currentUserInvitee?.isRemote} colors={COLORS.Success.T500.value} height={'2.25rem'}/>
              <ButtonPresenceStatus title={t(tKeys.home.calendar.event_details.information.presence.status
                .remote)} onPress={() => handlePresenceStatus(PresenceStatus?.Remote)} iconName={'remote'} isSelected={currentUserInvitee?.isRemote} colors={COLORS.Warning.T500.value} height={'2.25rem'}/>
              <ButtonPresenceStatus title={t(tKeys.home.calendar.event_details.information.presence.status
                .proxy)} onPress={() => handlePresenceStatus(PresenceStatus?.Proxy, currentUserInvitee?.proxyId)} iconName={'proxy'} isSelected={!!currentUserInvitee?.proxyId} colors={COLORS.Warning.T500.value} height={'2.25rem'}/>
              <ButtonPresenceStatus title={t(tKeys.home.calendar.event_details.information.presence.status
                .absent)} onPress={() => handlePresenceStatus(PresenceStatus?.Absent)} iconName={'close-cross'} isSelected={!!currentUserInvitee?.refusedOn &&
                !currentUserInvitee?.proxyId} colors={COLORS.Error.T500.value} height={'2.25rem'}/>
            </HStack>
          </>)}
    </VStack>);
}
export const EventDetailsMainInformations = chakra(EventDetailsMainInformationsComponent);
